import type { ErrorInfo } from 'react'

export const logError = (error: unknown, info: ErrorInfo) => {
  const err = error instanceof Error ? error : new Error(String(error))

  if (import.meta.env.DEV) {
    console.error('Error caught by error boundary:', err)
    console.error('Component stack:', info.componentStack)
  }
}
